import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import NoAccess from "../pages/noAccess/NoAccess";

const RoleBasedRoute = ({
  elements,
  fallback,
  permissions
}) => {
  const { role, can } = useAuth();

  if (!elements[role]) {
    return fallback ? <Navigate to={fallback} /> : <NoAccess />;
  }

  if (permissions?.[role] && !can(permissions[role])) {
    return <NoAccess />;
  }

  return elements[role];
};

RoleBasedRoute.propTypes = {
  elements: PropTypes.object,
  fallback: PropTypes.string,
  permissions: PropTypes.object,
}

export default RoleBasedRoute